import AgencyRowCheckbox from '@/components/distributors/modals/AgencyRowCheckbox';
import { Checkbox } from '@/components/ui/checkbox';
import { DistributorKind } from '@/types/auth/DistributorKind';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type SharedAgency = {
  allCircuitsAreShared: boolean;
  someCircuitsAreShared: boolean;
  isWorkingWithReceiver: boolean;
  createdAt: Date;
  id: string;
  name: string;
  kind: DistributorKind;
  network: {
    id: string;
    name: string;
  } | null;
};

export const AGENCY_SELECTION_COLUMNS = (
  t: Translator,
): ColumnDef<SharedAgency>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => <AgencyRowCheckbox row={row} />,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('modal.selectAgencies.columns.name'),
    cell: ({ row }) => (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            className="max-w-72 xl:max-w-96 inline-block overflow-hidden whitespace-nowrap text-ellipsis"
            aria-label="nom"
          >
            {row.original.name}
          </TooltipTrigger>
          <TooltipContent
            className="bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-lg"
            aria-label="nom complet"
          >
            {row.original.name}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ),
  },
  {
    accessorKey: 'network.name',
    header: t('modal.selectAgencies.columns.network'),
    cell: ({ row }) => (
      <span>
        {row.original.network?.name ??
          (row.original.kind === DistributorKind.TourOperator
            ? t('auth.profileSelector.tourOperator')
            : '—')}
      </span>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: t('modal.selectAgencies.columns.arrivalDate'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
];
